import { render, staticRenderFns } from "./MonitorarPresenciais.vue?vue&type=template&id=464e1aca&scoped=true"
import script from "./MonitorarPresenciais.vue?vue&type=script&lang=js"
export * from "./MonitorarPresenciais.vue?vue&type=script&lang=js"
import style0 from "./MonitorarPresenciais.vue?vue&type=style&index=0&id=464e1aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e1aca",
  null
  
)

export default component.exports